import {call, put, select} from "typed-redux-saga";
import {Api, ApiError} from "modules/utils/api";
import {
	closeSSOAdditionalFieldsModal,
	continueFetchData,
	openSSOAdditionalFieldsModal,
	requestProfileFailed,
	requestProfileSuccess,
	requestUserFailed,
	requestUserSuccess,
	saveProfile,
	saveProfileFailed,
	saveProfileSuccess,
} from "modules/actions";
import {isLoggedIn} from "modules/selectors";

export const requestUserSaga = function* () {
	try {
		const response = yield* call(Api.User.get);
		yield* put(requestUserSuccess(response.success.user));
	} catch (err) {
		yield* put(requestUserFailed());
	}
};

export const requestProfileSaga = function* () {
	try {
		const isLogged = yield* select(isLoggedIn);

		if (!isLogged) {
			yield* put(requestProfileFailed());
			return;
		}

		const response = yield* call(Api.Profile.get);
		const profile = response.success.profile;

		yield* put(requestProfileSuccess(profile));

		const isShowSSOAdditionalFieldsModal = !profile.terms;

		if (isShowSSOAdditionalFieldsModal) {
			yield* put(openSSOAdditionalFieldsModal());
		}
	} catch (err) {
		yield* put(requestProfileFailed());
	}
};

export const saveProfileSaga = function* ({payload}: ReturnType<typeof saveProfile>) {
	try {
		const response = yield* call(Api.Profile.save, payload);
		yield* put(saveProfileSuccess(response.success.profile));
		yield* put(closeSSOAdditionalFieldsModal());
		yield* put(continueFetchData());
	} catch (err) {
		const {message} = err as ApiError;
		yield* put(saveProfileFailed({form: message}));
	}
};
